import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { DropOffEffects } from '../drop-off/drop-off.effects';
import * as fromDropOff from './drop-off.reducer';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(fromDropOff.dropOffFeatureKey, fromDropOff.reducers, {
            metaReducers: fromDropOff.metaReducers,
        }),
        EffectsModule.forFeature([DropOffEffects]),
    ],
})
export class DropOffModule {}

export * as DropOffActions from './drop-off.actions';
export * as DropOffSelectors from './drop-off.selectors';
